<template>
  <div class="product-add">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">APP 前台展示</div>
      <el-form-item label="是否显示邀请奖励">
        <el-radio-group v-model="form.show_invite_reward">
          <el-radio label="1">显示</el-radio>
          <el-radio label="0">隐藏</el-radio>
        </el-radio-group>
        <div class="tips">控制 APP 前台是否展示「邀请奖励」相关入口或页面</div>
      </el-form-item>
      <div class="common-button-wrapper">
        <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import AppSettingApi from '@/api/appsetting.js';
import { formatModel } from '@/utils/base.js';

export default {
  data() {
    return {
      loading: false,
      form: {
        show_invite_reward: '1',
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      AppSettingApi.appConfigDetail({}, true)
        .then(res => {
          const data = res.data.data || {};
          this.form = formatModel(this.form, data);
          this.form.show_invite_reward = data.show_invite_reward != null
            ? String(data.show_invite_reward)
            : '1';
        })
        .catch(() => {});
    },
    onSubmit() {
      this.loading = true;
      AppSettingApi.editAppConfig(this.form, true)
        .then(() => {
          this.loading = false;
          this.$message.success('保存成功');
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appopen/part/appconfig.vue